module.exports = __webpack_public_path__ + "assets/right-arrow.png?b1ccc0e4456dbd8d15c2c8d8433075d8";